import React, { PureComponent, Fragment } from 'react';
import { func, string } from 'prop-types';
import classnames from 'classnames';
import { withLocalStorage } from 'connectors';
import { localStorageShape } from 'shapes';
import HistoryEntry from './HistoryEntry/HistoryEntry';
import './History.scss';

let isMounted;
class History extends PureComponent {
    static propTypes = {
        className: string,
        onHistorySelected: func.isRequired,
        localStorage: localStorageShape.isRequired,
    };

    static defaultProps = {
        className: '',
    };

    constructor(props) {
        super(props);

        this.state = {
            history: [],
        };
    }

    componentDidMount() {
        isMounted = true;
        this.props.localStorage.get().then(res => {
            if (isMounted) {
                this.setState({ history: res });
            }
        });
    }

    componentWillUnmount() {
        isMounted = false;
    }

    saveHistoryLocalStorage = () => {
        this.props.localStorage.set(this.state.history);
    };

    handleClearHistory = () => {
        this.setState({ history: [] }, () => this.saveHistoryLocalStorage());
    };

    handleHistoryEntryClick = value => {
        const { onHistorySelected } = this.props;
        if (onHistorySelected) {
            onHistorySelected(value);
        }
    };

    handleHistoryEntryDelete = value => {
        this.setState(
            {
                history: this.state.history.filter(
                    history => history !== value,
                ),
            },
            () => this.saveHistoryLocalStorage(),
        );
    };

    render() {
        const { className } = this.props;
        const { history } = this.state;
        const rootClassnames = classnames('searchBar__history', className);

        return (
            <div className={rootClassnames}>
                {this.state.history.length > 0 && (
                    <Fragment>
                        <div className="searchBar__history__header">
                            <div className="searchBar__history__title">
                                historique de recherche
                            </div>
                            <button
                                className="searchBar__history__clear"
                                onClick={this.handleClearHistory}
                            >
                                Vider mon historique
                            </button>
                        </div>

                        <div className="searchBar__history__list">
                            {history.map((historyEntry, index) => (
                                <HistoryEntry
                                    key={`${historyEntry}${index}`} // eslint-disable-line react/no-array-index-key
                                    value={historyEntry}
                                    onClick={this.handleHistoryEntryClick}
                                    onDelete={this.handleHistoryEntryDelete}
                                />
                            ))}
                        </div>
                    </Fragment>
                )}
            </div>
        );
    }
}

export default withLocalStorage('searchHistory')(History);
